import {Contenuto} from "./contenuto";

export class Blocco {
  id?: number;
  nome?: string;
  marker?:string;
  sezione?: string
  contenutiList?: Contenuto[];
  testo?: string;
  checked?: boolean;
  modifica?:boolean;
  contenuto?: Contenuto;
}
